<template>
  <div>DoencasCronicas</div>
</template>

<script>
export default {}
</script>

<style></style>
